import { styled } from "@mui/material";

import { BackBurger } from "@/Components/Icons/BackBurger";
import { Box } from "@/Components/v2/atoms/Box";
import { SimpleIconButton } from "@/Components/v2/atoms/Button";
import { Typography } from "@/Components/v2/atoms/Typography";

interface DrawerHeaderV2Props {
  title: string;
  toggleDrawer?: () => void;
  hideCloseIcon?: boolean;
}

const StyledDrawerHeader = styled("div")(() => ({
  margin: "0.5rem 0 0",
}));

export const DrawerHeaderV2: React.FC<DrawerHeaderV2Props> = ({
  title,
  toggleDrawer,
  hideCloseIcon = true,
}) => (
  <StyledDrawerHeader>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Typography variant="h3" sx={{ fontWeight: "600", fontSize: "1.375rem" }}>
        {title}
      </Typography>
      {!hideCloseIcon && toggleDrawer && (
        <SimpleIconButton
          onClick={toggleDrawer}
          aria-label="close drawer"
          color="inherit"
          data-testcomp="CloseDrawerV2"
        >
          <BackBurger />
        </SimpleIconButton>
      )}
    </Box>
  </StyledDrawerHeader>
);

export default DrawerHeaderV2;
